import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map, tap } from 'rxjs';
import { Models, Modules, Permission } from 'src/app/data/model/permission';
import { User, UserTableVisualization } from 'src/app/data/model/user';
import { VehicleEquipmentLogsNovarinislfComponent } from 'src/app/features/vehicle-equipment-logs/components/vehicle-equipment-logs-novarinislf/vehicle-equipment-logs-novarinislf.component';

@Component({
  selector: 'app-navigation-menu',
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationMenuComponent implements OnInit, OnChanges {
  public menu: Map<string, Menu[]> = new Map();

  currentMenu: Menu[];
 
  @Input() user: User;
  @Input() viewPermissions: Permission[];
  @Input() viewModules: UserTableVisualization[];
  isMobile = false;

  

  constructor(
    private translate: TranslateService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.menu.set('it', it);
    this.breakpointObserver.observe([Breakpoints.Handset])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
  }
  

  ngOnChanges(): void {
 
    this.currentMenu = this.authorizedMenu(this.menu.get(this.translate.currentLang));//modificato

  }
  

  ngOnInit(): void {
    /*console.log("INIT viewModules1234=",this.viewModules)
    this.currentMenu = this.authorizedMenu(
      this.menu.get(this.translate.currentLang)
    );*/

    this.translate.onLangChange.pipe(
      map((langEvent) => this.menu.get(langEvent.lang)),
      map((menu) => this.authorizedMenu(menu)),
      tap((menu) => (this.currentMenu = menu))
    );
  }

  authorizedMenu(menu: Menu[]): Menu[] {
    const auth_menu=menu
    .map((menu) => this.menuWithoutUnauthorizedChild(menu))
    .filter((menu) => menu.items.length > 0);
    return auth_menu
  }

  menuWithoutUnauthorizedChild(menu: Menu): Menu {
    return {
      ...menu,
      items: menu.items
        .map((child) => this.filterAndAuthorizeSubMenu(child))
        .filter((child) => this.filterChild(child) && (child.sub_menu?.items.length || !child.sub_menu)),
    };
  }


  filterAndAuthorizeSubMenu(child: MenuChild): MenuChild {
    if (child.sub_menu) {
      return {
        ...child,
        sub_menu: {
          ...child.sub_menu,
          items: child.sub_menu.items
            .map((subChild) => this.filterAndAuthorizeSubMenu(subChild))
            .filter((subChild) => this.filterChild(subChild)),
        },
      };
    }
    return child;
  }

  filterChild(child: MenuChild): boolean {
    if(this.user?.is_superuser){
      return !child.authorizationModel ||
      this.viewPermissions?.some(
        (permission) =>
          permission.model === child.authorizationModel.model &&
          permission.module === child.authorizationModel.module
        );
    } else {
      return !child.authorizationModel ||
      this.viewPermissions?.some(
        (permission) =>
          permission.model === child.authorizationModel.model &&
          permission.module === child.authorizationModel.module &&
          this.viewModules?.some((module) => module.module_code === child.authorizationModel.module_code)
      );
    }
  }
}

export type Menu = {
  label: string;
  items: MenuChild[];
};
export type SubMenu = {
  label: string;
  items: MenuChild[];
};
export type MenuChild = {
  label: string;
  link?: string[];
  sub_menu?: SubMenu;
  authorizationModel?: {
    model: Models;
    module: Modules;
    module_code: string;
  };
};

export const it: Menu[] = [
  {
    label: 'Smart Bin',
    items: [
      {
        label: 'Anagrafica Smart Bin',
        link: ['/smart-bin'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.SMARTBIN,
          module_code: '0047',
        },
      },
      /*{
        label: 'Tessere Smart Bin',
        link: ['/card-smart-bin'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.SMARTBIN,
        },
      },*/
      {
        label: 'Registro Conferimenti',
        link: ['/smart-bin-conferrals'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.SMARTBIN,
          module_code:'0046',
        },
      },
      {
        label: 'Registro Svoutamenti',
        link: ['/smart-bin-emptying'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.SMARTBIN,
          module_code:'0045',
        },
      }
    ],
  },
  {
    label: 'Mappe',
    items: [
      {
        label: 'Mappa Contenitori',
        link: ['/containers-map'],
        authorizationModel: {
          module: Modules.REGISTRY,
          model: Models.TAGRES,
          module_code:'0044',
        },
      },
      {
        label: 'Mappa Raccolta Contenitori',
        link: ['/readings-events-container-map'],
        authorizationModel: {
          module: Modules.TELEMETRY,
          model: Models.READERDATA,
          module_code:'0043',
        },
      },
      {
        label: 'Mappa Cestini',
        link: ['/tag-map'],
        authorizationModel: {
          module: Modules.TAG_APP_API,
          model: Models.TAG_EVENT,
          module_code:'0042',
        },
      },
      {
        label: 'Mappa Automezzi',
        link: ['/map'],
        authorizationModel: {
          module: Modules.TELEMETRY,
          model: Models.GPSTRACK,
          module_code:'0041',
        }
      },
      {
        label: 'Smart Bin Map',
        link: ['/smart-bin-map'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.SMARTBIN,
          module_code:'0040',
        },
      }
    ],
  },
  {
    label: 'Ecologia e Servizi',
    items: [
      {
        label: 'Centri di Raccolta',
        link: ['/eco-point'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.ECOPOINT,
          module_code:'0039',
        },
      },
      {
        label: 'Operatori',
        link: ['/operators'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.OPERATOR,
          module_code:'0038',
        },
      },
      {
        label: 'Chioschi',
        link: ['/kiosks'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.KIOSK,
          module_code:'0037',
        },
      },
      {
        label: 'Liste di raccolta',
        link: ['/taggable-resource-list'],
        authorizationModel: {
          module: Modules.MODA_NEW,
          model: Models.TAGRESLIST,
          module_code:'0036',
        },
      },
      {
        label: 'Percorsi di raccolta',
        link: ['/taggable-resource-pickup'],
        authorizationModel: {
          module: Modules.MODA_NEW,
          model: Models.TAGRESPICKUPROUTE,
          module_code:'0035',
        },
      },
      {
        label: 'Anagrafiche',
        sub_menu:{
          label: 'Anagrafiche',
          items: [
            {
              label: 'Elenco Utenze',
              link: ['/customer_contract'],
              authorizationModel: {
                module: Modules.REGISTRY,
                model: Models.CONTRACT,
                module_code:'0034',
              },
            },
            {
              label: 'Tessere',
              link: ['/cards-management'],
              authorizationModel: {
                module: Modules.MODA, 
                model: Models.CARDUTILITY,
                module_code:'0033',
              },
            },
            {
              label: 'Contenitori',
              link: ['/taggable-resource'],
              authorizationModel: {
                module: Modules.REGISTRY, 
                model: Models.TAGRES,
                module_code:'0032',
              },
            },
            {
              label: 'Tag',
              link: ['/tag'],
              authorizationModel: {
                module: Modules.REGISTRY, 
                model: Models.TAG,
                module_code:'0031',
              },
            },
          ],
        }
      }
    ],
  },
  {
    label: 'Centri Del Riuso',
    items: [
      {
        label: 'Anagrafica Centri Del Riuso',
        link: ['/cdri'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.ECOPOINT,
          module_code:'0030',
        },
      },
      {
        label: 'Registro di Carico',
        link: ['/delivery'],
        authorizationModel: {
          module: Modules.REUSECENTER,
          model: Models.DELIVERY,
          module_code:'0029',
        },
      },
      {
        label: 'Registro di Scarico',
        link: ['/pickup'],
        authorizationModel: {
          module: Modules.REUSECENTER,
          model: Models.DELIVERY,
          module_code:'0028',
        },
      },
      {
        label: 'Codici da Stampare',
        link: ['/delivery-codes'],
        authorizationModel: {
          module: Modules.REUSECENTER,
          model: Models.DELCODE,
          module_code:'0027',
        },
      },
      {
        label: 'Documenti',
        link: ['/reuse-docs'],
        authorizationModel: {
          module: Modules.REUSECENTER,
          model: Models.DELDOCUMENTS,
          module_code:'0026',
        },
      },
      {
        label: 'Registro Beni In Uscita a Fine Giacenza',
        link: ['/delivery-over-time'],
        authorizationModel: {
          module: Modules.REUSECENTER,
          model: Models.DELIVERY,
          module_code:'0025',
        },
      },
    ],
  },
  {
    label: 'Report',
    items: [
      {
        label: 'Report Operatori',
        link:  ['/drivers-job-report'],
        authorizationModel: {
          module: Modules.REPORT,
          model: Models.CUSTOMREPORTS,
          module_code:'0024',
        },
      },
      {
        label: 'Grafana',
        link:  ['/grafana-reports'],
        authorizationModel: {
          module: Modules.REPORT,
          model: Models.GRAFANA,
          module_code:'0023',
        },
      },
      {
        label: 'Conferimenti',
        link:  ['/conferrals'],
        authorizationModel: {
          module: Modules.CONFERRALS,
          model: Models.CONFERRAL,
          module_code:'0022',
        },
      },
      {
        label: 'Utenze Sovrasoglia',
        link:  ['/conferral-over-limits'],
        authorizationModel: {
          module: Modules.CONFERRALS,
          model: Models.CONFERRAL,
          module_code:'0021',
        },
      },
      {
        label: 'Report Spazzatrici',
        link:  ['/sweeper-reports'],
        authorizationModel: {
          module: Modules.TELEMETRY,
          model: Models.GPSTRACK,
          module_code:'0020',
        },
      },
      {
        label: 'Report Attività Mezzi',
        link:  ['/customreports'],
        authorizationModel: {
          module: Modules.REPORT,
          model: Models.CUSTOMREPORTS,
          module_code:'0019',
        },
      },
      {
        label: 'Report Soste-Pause Mezzi',
        link:  ['/customreports2'],
        authorizationModel: {
          module: Modules.REPORT,
          model: Models.CUSTOMREPORTS,
          module_code:'0018',
        },
      },
      {
        label: 'Report Raccolta Contenitori',
        link:  ['/report-tag-event'],
        authorizationModel: {
          module: Modules.TELEMETRY,
          model: Models.READERDATA,
          module_code:'0017',
        },
      },
      {
        label: 'Report Segnalazioni Contenitori',
        link:  ['/report-tag-anomalies'],
        authorizationModel: {
          module: Modules.TELEMETRY,
          model: Models.DEVICE_EVENT,
          module_code:'0016',
        },
      },
    ]
  },
  {
    label: 'Gestione Dispositivi',
    items: [
      {
        label: 'Device collector',
        link: ['/device-collector'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.DEVICE_COLLECTOR,
          module_code:'0015',
        },
      },
      {
        label: 'Dispositivi',
        link: ['/device'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.DEVICE,
          module_code:'0014',
        },
      },
      {
        label: 'Lettori',
        link: ['/readers'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.READER,
          module_code:'0013',
        },
      },
    ],
  },
  {
    label: 'Gestione Automezzi',
    items: [
      {
        label: 'Ordini di servizio',
        link: ['/service-order'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.ORDINIS,
          module_code:'0012',
        },
      },
      {
        label: 'Percorsi',
        link: ['/waypoints-lap'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.GPSLAP,
          module_code:'0011',
        },
      },
      {
        label: 'Veicoli',
        link: ['/vehicle'],
        authorizationModel: {
          module: Modules.DATA_COLLECTOR,
          model: Models.VEHICLE,
          module_code:'0010',
        },
      },
      {
        label: 'Codici QR',
        link: ['/qr-codes'],
        authorizationModel: {
          module: Modules.MOBILE,
          model: Models.VEHICLEQRCODE,
          module_code:'0009',
        },
      },
      {
        label: 'Whitelist',
        link: ['/whitelist'],
        authorizationModel: {
          module: Modules.BIN_COLLECTION,
          model: Models.WHITELIST,
          module_code:'0008',
        },
      },
      {
        label: 'Telemetrie',
        sub_menu:{
          label: 'Telemetrie',
          items: [
            {
              label: 'Elenco telemetrie',
              link: ['/telemetries'],
              authorizationModel: {
                module: Modules.TELEMETRY,
                model: Models.TELEMETRY,
                module_code:'0007',
              },
            },
            {
              label: 'Anomalie',
              link: ['/device-event'],
              authorizationModel: {
                module: Modules.TELEMETRY,
                model: Models.DEVICEEVENT,
                module_code:'0006',
              },
            },
            {
              label: 'Telaio',
              link: ['/chassis-state'],
              authorizationModel: {
                module: Modules.TELEMETRY,
                model: Models.CHASSIS,
                module_code:'0005',
              },
            }
          ],
        }
      }/*,
      {
        label: 'Servizi Tag',
        sub_menu:{
          label: 'Servizi Tag',
          items: [
            {
              label: 'Whitelist',
              link: ['/whitelist'],
              authorizationModel: {
                module: Modules.BIN_COLLECTION,
                model: Models.WHITELIST,
              },
            }
          ],
        }
      }*/
    ],
  },
  {
    label: 'Gestione Portale',
    items: [
      {
        label: 'Utenti',
        link: ['/user'],
        authorizationModel: {
          module: Modules.AUTH,
          model: Models.PORTAL_USER,
          module_code:'0004',
        },
      },
      {
        label: 'Gruppi',
        link: ['/group'],
        authorizationModel: {
          model: Models.PORTAL_GROUP,
          module: Modules.MANAGEMENT,
          module_code:'0001',
        },
      },
      {
        label: 'Gruppi di permessi',
        link: ['/permission-groups'],
        authorizationModel: {
          model: Models.PORTAL_USER,
          module: Modules.AUTH,
          module_code:'0002',
        },
      },
      {
        label: 'Servizi registrati',
        link: ['/app-management'],
        authorizationModel: {
          model: Models.APPMANAGEMENT,
          module: Modules.SERVICE,
          module_code:'0003',
        },
      },
      /*{
        label: 'Licenze Attive',
        link: ['/refresh-token'],
        authorizationModel: {
          model: Models.CUSTOMREFRESHTOKEN,
          module: Modules.SERVICE,
        },
      },*/
    ],
  },
];
